export { default } from 'styled-up/dist/CheckboxInput';
